import { DrawingVertex } from '../objects/DrawingVertex';

export class DrawingVertexList {
	first: DrawingVertex | null = null;
	last: DrawingVertex | null = null;
	length = 0;
	isClosed = false;

	add(vertex: DrawingVertex) {
		if (!this.first) {
			this.first = vertex;
			this.last = vertex;
		} else {
			if (!this.last) return;

			this.last.next = vertex;
			vertex.prev = this.last;
			this.last = vertex;
		}

		this.length++;
	}

	remove(vertex: DrawingVertex) {
		if (this.isClosed) this.openLoop();

		if (vertex.prev) vertex.prev.next = null;
		if (vertex.next) vertex.next.prev = null;

		if (this.first === vertex) this.first = vertex.next;
		if (this.last === vertex) this.last = vertex.prev;

		this.length--;

		vertex.dispose();
	}

	clear() {
		this.forEach((v) => v.dispose());
		this.first = null;
		this.last = null;
		this.length = 0;
		this.isClosed = false;
	}

	closeLoop() {
		if (!this.first || !this.last || this.length < 3) return;

		this.last.next = this.first;
		this.first.prev = this.last;
		this.isClosed = true;
	}

	openLoop() {
		this.isClosed = false;
	}

	forEach(callback: (v: DrawingVertex) => void) {
		let current = this.first;
		const visited = new Set<DrawingVertex>();

		while (current && !visited.has(current)) {
			callback(current);
			visited.add(current);
			current = current.next;
		}
	}

	toArray(filterRedundantVerticies = false): DrawingVertex[] {
		const arr: DrawingVertex[] = [];

		this.forEach((v) => {
			if (!filterRedundantVerticies) {
				arr.push(v);
				return;
			}

			const prev = v.prev;
			const next = v.next;

			if (!prev || !next) {
				arr.push(v);
				return;
			}

			const sameX =
				prev.position.x === v.position.x && v.position.x === next.position.x;
			const sameY =
				prev.position.y === v.position.y && v.position.y === next.position.y;

			if (!sameX && !sameY) arr.push(v);
		});

		return arr;
	}

	exportVertices() {
		return this.toArray(true).map((v) => v.position.toArray());
	}

	isLoopClosed() {
		return this.isClosed;
	}
}
